/* eslint-disable no-empty */
import { I18n } from 'react-redux-i18n';

import ProductsServer from '../../server/products';
import tagManager from '../../services/tagManager';
import { addLoading, removeLoading } from './loading';

export const setFiltersSidebar = (sortByClickS, sortByClickP, sortByClickB) => ({
  type: 'SIDEBAR_FILTERS',
  sortByClickS,
  sortByClickP,
  sortByClickB,
});

export const resetProducts = () => ({
  type: 'PRODUCTS_RESET',
});

export const setPricing = (listType, products) => ({
  type: 'PRODUCTS_PRICING_SET',
  listType,
  products,
});

export const setList = (products, filters, suggest, searchId) => ({
  type: 'PRODUCTS_LIST_SET',
  products,
  filters,
  suggest,
  searchId,
});

export const setOrderType = orderType => ({
  type: 'PRODUCTS_ORDER_TYPE',
  orderType,
});

export const setSearchSuggests = suggests => ({
  type: 'PRODUCTS_SEARCH_SUGGESTS',
  suggests,
});

export const getProductsPricing = products => async (dispatch, getState) => {
  const selectedContract = getState().contracts.selected;
  if (selectedContract) {
    const { client = {}, userId } = selectedContract;
    const pricing = await ProductsServer.getPricing(client.id, userId, products.map(p => p.id));
    products = products.map((item) => {
      const price = pricing.find(p => p.id === item.id);
      if (price) {
        if (!item.price.isContract) item.price = { ...item.price, ...price };
        else item.price = { ...item.price, hasPrice: true };
      } else if (item.price) {
        item.price.contactUs = true;
      } else {
        item.price = { contactUs: true };
      }
      return { ...item };
    });
  }
  return products;
};

export const getPricing = (listType, products, searchOptions = {}) => async (dispatch) => {
  products = await dispatch(getProductsPricing(products));

  if (products && products.length) {
    if (searchOptions.order && searchOptions.order !== 'relevance') {
      products = products.sort((a, b) => {
        if (searchOptions.order && searchOptions.order === 'maxPrice') return b.price.value - a.price.value;
        return a.price.value - b.price.value;
      });
    }
  }
  dispatch(setPricing(listType, products));
};

const getProductsSearchItems = async (clientId, searchOptions, searchEngine = '') => {
  if (searchEngine === 'sonepar') {
    if (clientId) return ProductsServer.getClientSoneparSearch(clientId, searchOptions);
    return ProductsServer.getSoneparSearch(clientId, searchOptions);
  }
  if (clientId) return ProductsServer.getClientSearch(clientId, searchOptions);
  return ProductsServer.getSearch(searchOptions);
};

const getProductsFilter = async (clientId, searchOptions) => {
  if (clientId) return ProductsServer.getClientFilters(clientId, searchOptions);
  return ProductsServer.getFilters(searchOptions);
};

const prepareSendToTagManager = async (search, products) => {
  try {
    const productsToSend = [];
    const productsPromotionToSend = [];

    products.forEach((it, index) => {
      productsToSend.push({
        name: it.name,
        id: it.code,
        price: `${it.price ? (it.price.value || 0) : 0}`,
        brand: it.brand ? it.brand.description : '',
        category: it.category ? it.category.name : '',
        list: `${I18n.t('resultsSearch')}${search && search.text ? ` (${search.text})` : ''}`,
        position: index + 1,
      });

      if (it.price && it.price.promo) {
        productsPromotionToSend.push({
          id: it.code,
          name: it.name,
          creative: `${I18n.t('resultsSearch')}${search && search.text ? ` (${search.text})` : ''}`,
          position: index + 1,
        });
      }
    });

    tagManager.ecommerceImpressions(productsToSend);
    tagManager.ecommercePromotions(productsPromotionToSend);
  } catch (e) {}
};

export const getProductsSearch = (search = {}, resetFilter = false) => async (dispatch, getState) => {
  const clientId = getState().contracts.selected && getState().contracts.selected.client.id;
  const searchEngine = getState().settings.searchEngine || '';
  const previousSearchId = getState().products.searchId || 0;

  let products = [];
  let filters = [];
  let suggest = [];
  let searchId = 0;

  dispatch(addLoading());
  try {
    let mainCategories;
    let subCategories;
    if (search.categories) {
      mainCategories = search.categories
        .filter(categoryId => getState().settings.categories.find(c => c.id === categoryId));
      subCategories = search.categories.filter(categoryId => mainCategories.indexOf(categoryId) === -1);
    }

    const page = search.page || 1;
    const searchOptions = {
      skip: (page - 1) * search.limit,
      limit: search.limit,
      text: search.text,
      mainCategories,
      subCategories,
      brands: search.brands,
      pdmsModifiers: search.pdmsModifiers,
      pdmsParticulars: search.pdmsParticulars,
      type: search.type,
      order: search.order,
      minPrice: search.minPrice,
      maxPrice: search.maxPrice,
      previousSearchId,
    };

    if (['elastic', 'sonepar'].includes(searchEngine)) {
      [{
        products, suggest, filters, searchId,
      }] = await Promise.all([getProductsSearchItems(clientId, searchOptions, searchEngine)]);

      if (!resetFilter) filters = false;
    } else {
      [{ products, suggest }, filters] = await Promise.all([
        getProductsSearchItems(clientId, searchOptions),
        resetFilter && getProductsFilter(clientId, searchOptions),
      ]);
    }

    dispatch(setList(products, filters, suggest, searchId));
    if (clientId && products && products.length) dispatch(getPricing('list', products, searchOptions));
    dispatch(setSearchSuggests(suggest));

    prepareSendToTagManager(search, products);
  } finally {
    dispatch(removeLoading());
  }
};

export const setFeatured = products => ({
  type: 'PRODUCTS_FEATURED_SET',
  products,
});

export const getProductsFeatured = force => async (dispatch, getState) => {
  if (force || !getState().products.featured) {
    const clientId = getState().contracts.selected && getState().contracts.selected.client.id;
    const products = clientId
      ? await ProductsServer.getClientFeatured(clientId)
      : await ProductsServer.getFeatured();

    dispatch(setFeatured(products));
    if (clientId) dispatch(getPricing('featured', products));
  }
};

export const getProductsSimilar = productId => async (dispatch, getState) => {
  const { selected } = getState().contracts;

  if (!selected) return [];

  const clientId = selected.client && selected.client.id;
  const { similarityPermission } = selected;

  if (!similarityPermission || !clientId) return [];

  return ProductsServer.getClientSimilar(clientId, productId);
};

export const getProductsCrossSelling = productId => async (dispatch, getState) => {
  const { selected = {} } = getState().contracts;

  if (!selected) return [];

  const clientId = selected.client && selected.client.id;
  const { crossSellingPermission } = selected;

  if (!crossSellingPermission || !clientId) return [];

  return ProductsServer.getClientCrossSelling(clientId, productId);
};

export const setPromotions = products => ({
  type: 'PRODUCTS_PROMOTIONS_SET',
  products,
});

export const getProductsPromotions = force => async (dispatch, getState) => {
  try {
    const clientId = getState().contracts.selected && getState().contracts.selected.client.id;

    if (clientId && (force || !getState().products.promotions)) {
      const products = await ProductsServer.getClientPromotions(clientId);
      dispatch(setPromotions(products));
    }
  } catch (e) {}
};

export const setRecommended = products => ({
  type: 'PRODUCTS_RECOMMENDED_SET',
  products,
});

export const getProductsRecommended = force => async (dispatch, getState) => {
  try {
    const clientId = getState().contracts.selected && getState().contracts.selected.client.id;

    if (clientId && (force || !getState().products.recommended)) {
      const products = await ProductsServer.getClientRecommended(clientId);
      dispatch(setRecommended(products));
    }
  } catch (e) {}
};

export const getProductDetails = (productId, code, forceToGetProductLeadTime = false) => async (dispatch, getState) => {
  dispatch(addLoading());
  try {
    const { contracts, auth } = getState();
    const clientId = contracts.selected && contracts.selected.client.id;
    const isPunchOut = auth.scope === 'punchout';
    const product = clientId
      ? await ProductsServer.getClientDetails(clientId, productId, code, isPunchOut, forceToGetProductLeadTime)
      : await ProductsServer.getDetails(productId);

    if (product.price && product.price.value) {
      product.price.hasPrice = true;
    } else if (product.price) {
      product.price.contactUs = true;
    } else {
      product.price = {
        contactUs: true,
      };
    }

    return product;
  } finally {
    dispatch(removeLoading());
  }
};

export const getSuggests = (term, client) => async (dispatch) => {
  try {
    let suggests = [];

    if (term.trim() && term.length >= 2 && client) {
      suggests = await ProductsServer.getSuggests(term, client);
    }

    if (term.trim() && term.length >= 2 && !client) {
      suggests = await ProductsServer.getSuggestsNoClient(term);
    }
    dispatch(setSearchSuggests(suggests));
  } finally { }
};
